export const translations = {
  en: {
    // Common
    'app.title': 'My Immigrant Journey',
    'language.english': 'English',
    'button.next': 'Next',
    'button.previous': 'Previous',
    'button.skip': 'Skip',
    'button.finish': 'Finish',
    'button.start': 'Get Started',
    'button.save': 'Save',
    'button.calculate': 'Calculate',
    'button.back': 'Back to Guide',
    
    // Auth
    'auth.signOut': 'Sign Out',
    
    // Profile
    'profile.settings': 'Profile Settings',
    
    // Help
    'help.support': 'Help & Support',
    
    // Library
    'library.title': 'Knowledge Library',
    'library.intro': 'Explore our collection of resources for immigrants',
    'library.completed': 'Completed',
    'library.mark': 'Mark as Read',
    'category.all': 'All Topics',
    'category.basics': 'Step 1: Getting Started',
    'category.documents': 'Step 2: Documents',
    'category.housing': 'Step 3: Housing',
    'category.employment': 'Step 4: Employment',
    'category.healthcare': 'Step 5: Healthcare',
    
    // Steps
    'step.1.title': 'Step 1: Welcome Checklist',
    'step.2.title': 'Step 2: Essential Documents',
    'step.3.title': 'Step 3: Banking & Credit',
    'step.4.title': 'Step 4: Housing & Utilities',
    'step.5.title': 'Step 5: Employment & Taxes',
    'step.1.intro': 'Start your journey in America with these essential tasks',
    'step.2.intro': 'Secure important documents for your new life',
    'step.3.intro': 'Build your financial foundation in the U.S.',
    'step.4.intro': 'Find and set up your home in America',
    'step.5.intro': 'Understand employment and tax requirements',
    
    // Dashboard
    'dashboard.welcome': 'Welcome to America!',
    'dashboard.journey': 'Your Immigration Journey',
    'dashboard.progress': 'Track your progress',
    'dashboard.resources': 'Essential Resources',
    'dashboard.consultation': 'Need Immigration Help?',
    'dashboard.book': 'Book Free Consultation',
    
    // Journey
    'journey.title': 'Your Immigration Journey',
    'journey.subtitle': 'Navigate your new life in America with step-by-step guidance',
    'journey.premium': 'Unlock Premium Content',
    'journey.upgrade': 'Upgrade Now',
    
    // Immigration Steps
    'immigration.new': 'New to America',
    'immigration.banking': 'Banking & Credit',
    'immigration.housing': 'Housing & Utilities',
    'immigration.taxes': 'Taxes & Employment',
    'immigration.healthcare': 'Healthcare',
    'immigration.education': 'Education & Family',
    'immigration.business': 'Self-Employment',
    
    // Course Actions
    'course.start': 'Start Learning',
    'course.continue': 'Continue Learning',
    'course.upgrade': 'Upgrade to Unlock',
    'course.complete': 'Course Complete!',
    
    // Rest of the translations...
  }
};